import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import TextLink from '@kiwicom/orbit-components/lib/TextLink';
import ChevronBackward from '@kiwicom/orbit-components/lib/icons/ChevronBackward';
import { useRouter } from 'next/router';
import { Category, createEventLogUnified, UIAction } from '@/common/services/logging';
import { log } from '@kiwicom/nitro/lib/services/log/logger';

import usePathToMmb from '../../services/hooks/usePathToMmb';

const BreadcrumbNavigationToMmb = () => {
  const { pathname, push } = useRouter();
  const pathToMmb = usePathToMmb();

  const onClick = async (event: React.SyntheticEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    await log(
      createEventLogUnified(Category.COMMON, UIAction.BreadcrumbClicked, 'back to my trip'),
      {
        pathname,
      },
    ).catch();

    void push(pathToMmb);
  };

  return (
    <TextLink
      onClick={onClick}
      href={pathToMmb}
      type="secondary"
      size="normal"
      iconLeft={<ChevronBackward reverseOnRtl ariaHidden />}
    >
      <FormattedMessage id="mmb.breadcrumbs.manage_my_trip" defaultMessage="My trip" />
    </TextLink>
  );
};

export default BreadcrumbNavigationToMmb;
